G.ActionProcessMatch = function(board,am,args) {

	G.Action.call(this,board,am,args);
	this.preFall = true;
	this.processed = false;

};

G.ActionProcessMatch.prototype = Object.create(G.Action.prototype);

G.ActionProcessMatch.prototype.update = function() {

	//if (!this.board.duringAnimation && !this.board.duringFall && (this.board.checkMatchList != false || this.board.checkSpecialMatchList != false)) {
	if (!this.board.duringAnimation && !this.board.duringFall) {
		this.board.matcher.processMatchList();
		//G.lvl.increaseCombo();
	};

	if (!this.board.duringAnimation && !this.board.duringFall && this.board.checkMatchList == false && this.board.checkSpecialMatchList == false) {
		
		this.am.newAction('processFall');
		this.finish();
		//
	}	

};